import barba from "@barba/core";
import barbaCss from "@barba/css";
import setupContentCardsAnimations from "./content-card";
import AguaFabricSearchUI from "../ui-components/fabric-select-filter";
import inspireMeImage from "../page-animations";
import coverpageTransitions from "./cover-page";
import anime from "animejs/lib/anime.es.js";
import closeSidedrawer from "../ui-components/side-drawer";
import { setupPageModals, closePageModal } from "../ui-components/page-modal";
import pageScrollReveal from "../page-animations/scroll-reveal";
import enableGlideJs from "../ui-components/glide";
import loadingAttributePolyfill from "loading-attribute-polyfill";

barba.use(barbaCss);

const blocker = document.querySelectorAll(".blocker");

var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

console.log("isIE11", isIE11);

if (isIE11) {
	
	const lazyLoadEls = document.querySelectorAll("noscript.loading-lazy");

	lazyLoadEls.forEach((el) => {
		loadingAttributePolyfill.prepareElement(el);
	});

	new AguaFabricSearchUI();
	inspireMeImage();
	pageScrollReveal();
	setupPageModals();

	if (blocker.length > 0) {
		blocker.forEach((block) => block.remove());
	}

} else {
	
	barba.hooks.enter((data) => {
		window.scrollTo(0, 0);
	});

	barba.hooks.before((data) => {
		const url = data.next.url.href.split("?");
		data.next.url.href = url[0];

		window.history.pushState("", "", url[0]);

		return data;
	});

	barba.hooks.beforeLeave((data) => {
		closeSidedrawer();
		closePageModal();
	});

	barba.hooks.afterEnter((data) => {
		setupContentCardsAnimations();
		new AguaFabricSearchUI();
		inspireMeImage();
		pageScrollReveal();
		setupPageModals();
		enableGlideJs();

		const lazyLoadEls = document.querySelectorAll("noscript.loading-lazy");

		lazyLoadEls.forEach((el) => {
			loadingAttributePolyfill.prepareElement(el);
		});

		// This is to stop the page flash on first load
		const blocker = document.querySelectorAll(".blocker");
		if (blocker.length > 0) {
			blocker.forEach((block) => block.remove());
		}
	});

	barba.hooks.after((data) => {
		enableGlideJs();
	});

	barba.init({
		debug: true,
		timeout: 5000,
		transitions: [
			{
				name: "home",
				beforeOnce() {
					const tl = anime.timeline({
						duration: 3000,
						easing: "easeOutCubic",
					});
					tl.add({
						targets: ".blocker",
						opacity: [100, 0],
						duration: 10,
						easing: "easeOutCubic",
					})
						.add({
							targets: ".global-header",
							scaleY: [0, 1],
							translateY: [-30, 0],
							duration: 1000,
							easing: "easeOutCubic",
						})
						.add({
							targets: ".global-header__logo, .global-snackbar__text",
							opacity: [0, 1],
							duration: 3000,
						})
						.add(
							{
								targets: ".global-header__menu, .global-header__menu-toggle",
								translateY: [100, 0],
								delay: anime.stagger(500),
								duration: 1000,
								easing: "easeOutCubic",
							},
							"500"
						)
						.add(
							{
								targets: "main",
								opacity: [0, 1],
								duration: 1000,
								easing: "easeOutCubic",
							},
							"1000"
						);
				},
				once() {},
				afterOnce() {},
			},
			{
				name: "coverpage",
				beforeLeave() {
					const done = this.async();
					coverpageTransitions.beforeLeave(done);
				},
				beforeEnter() {},
				enter() {},
				afterEnter() {
					const done = this.async();
					coverpageTransitions.afterEnter(done);
				},
			},
			{
				name: "fade",
				from: {
					custom: ({ current, next }) => {
						return current.namespace === next.namespace;
					},
				},
				to: {
					custom: ({ current, next }) => {
						return current.namespace === next.namespace;
					},
				},
				beforeLeave(data) {
					const done = this.async();
					data.next.container.style.opacity = 0; // To stop page flashing

					const tl = anime.timeline({
						duration: 700,
					});
					tl.add({
						targets: data.current.container,
						opacity: [1, 0],
						easing: "easeInOutCubic",
						complete: function () {
							done();
						},
					});
				},
				beforeEnter() {},
				enter() {},
				afterEnter(data) {
					const done = this.async();
					const tl = anime.timeline({
						duration: 700,
					});
					tl.add({
						targets: data.next.container,
						opacity: [0, 1],
						easing: "easeInOutCubic",
						complete: function () {
							done();
						},
					});
				},
			},
		],
	});
}
